import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, switchMap, map, combineLatest } from 'rxjs/operators';
import { AutenticacaoService } from './autenticacao/autenticacao.service';
import { CabecalhoInfo, CabecalhoService } from './core/cabecalho-conteudo/cabecalho.service';
import { ConteudoCaminho } from './core/cabecalho-conteudo/conteudo-caminho';
import { AppUpdateService } from './core/app-update.service';
import * as Sentry from "@sentry/angular";
import { UsuarioService } from './autenticacao/usuario.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent implements OnInit{
  title = 'cliente';

  constructor(private autenticacao: AutenticacaoService, 
    private cabecalhoService: CabecalhoService,
    private router: Router, 
    private activatedRoute: ActivatedRoute,
    private user: UsuarioService,
    private appUpdateService: AppUpdateService,
    private titleService: Title) {

      this.autenticacao.inicializacaoStatus.subscribe((status) => {
        if(status) {
          let user = this.user.consultarUsuario();
          Sentry.setUser({
            id: user?.id,
            username: user?.username
          });
        }
      })

    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      map(e => e as NavigationEnd),
      switchMap((ev: NavigationEnd) => {
        let a: ActivatedRoute = this.activatedRoute;

        while(a.firstChild) {
          a = a.firstChild;
        }

        return a.data;
    })
    ).subscribe((result: any) => {

      //var conteudoId: string = result.paramMap.get('conteudoId');
      var titulo: string = result['titulo'];
      var subtitulo: string = result['subtitulo'];
      var conteudoCaminho: ConteudoCaminho[] = result['conteudoCaminho'];

      this.titleService.setTitle('SMOSaude - ' + titulo);

      window.scrollTo({ top: 0 });

      this.cabecalhoService.$status.next(new CabecalhoInfo({
        conteudoCaminho: conteudoCaminho,
        titulo: titulo,
        subtitulo: subtitulo,
        ///conteudoId: conteudoId,
      }));
    });
  }

  ngOnInit(): void {
    this.appUpdateService.checkForUpdates();
  }
}
